// import React from 'react'
import useSWR from 'swr'

export default function useCountries() {
  const {data: countries, error, isValidating} = useSWR('collections/countries')

  return {
    countries: countries?.data,
    isLoading: isValidating,
    isError: error
  }
}